import React, { useEffect, useState } from "react";
import { GoLocation } from "react-icons/go";
import moment from "moment";
import { Link } from "react-router-dom";
import { FiEdit3, FiDelete } from 'react-icons/fi';
import CustomButton from "./CustomButton";
import DeleteConfirmationDialog from '../components/deletealert';
import axios from "axios";
import { jwtDecode } from "jwt-decode";


const JobCard = ({ job, profileUrl, info, isCompany }) => {
  const [isCompanyProfile, setIsCompanyProfile] = useState(false);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
  const [productIdToDelete, setProductIdToDelete] = useState('');
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [token] = useState(localStorage.getItem('token'));
  const [userId, setUserId] = useState('');

  useEffect(() => {
    if(token){
    const decodedToken = jwtDecode(token);
    setUserId(decodedToken.userId);}
    console.log(userId);
  }, [token , userId]);

  useEffect(() => {
    setIsCompanyProfile(isCompany);
  }, [isCompany]);

  const handleDeleteProduct = () => {
    setProductIdToDelete(job._id);
    setIsDeleteConfirmationOpen(true);
  };

  const confirmDeleteProduct = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/job/delete-job/${productIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setDeleteSuccess(true);
      setIsDeleteConfirmationOpen(false);
      // Hide success message after 3 seconds

    } catch (error) {
      console.error('Error deleting product:', error);
      setDeleteError(true);
    }
  };

  const cancelDeleteProduct = () => {
    setIsDeleteConfirmationOpen(false);
  };
  const backtojob =()=>{
    setTimeout(() => {
      setDeleteSuccess(false);
      window.location.reload();
    }, 500);
  }
 return (
      <><div className="w-full md:w-[16rem] 2xl:w-[18rem] h-[16rem] md:h-[18rem]  bg-white shadow-lg rounded-md px-3 py-5 flex flex-col justify-between">
     <Link to={`/job-detail/${job?._id}`} className="text-decoration-none">
       <div className="flex items-center">
         <img
           src={profileUrl}
           alt={info?.name}
           className="w-14 h-14 rounded-2xl mr-4" />
         <div>
           <p className="text-lg font-semibold truncate">{job?.jobTitle}</p>
           <span className="flex gap-2 items-center text-sm text-gray-500">
             <GoLocation className="text-slate-900" />
             {job?.location}
           </span>
         </div>
       </div>
       <div className="py-3">
         <p className="text-sm">
           {job?.detail[0]?.desc?.slice(0, 150) + "..."}
         </p>
       </div>
       <div className="flex items-center justify-between">
         <p className="bg-[#1d4fd826] text-[#1d4fd8] py-0.5 px-1.5 rounded font-semibold text-sm">
           {job?.jobType}
         </p>
         <span className="text-gray-500 text-sm">
           {moment(job?.createdAt).fromNow()}
         </span>
       </div>
     </Link>
     {isCompanyProfile && (
       <div className="flex justify-between mt-1 ">
         <Link to={`/update-job/${job?._id}`}>
           <CustomButton
             title='Edit Job'
             iconRight={<FiEdit3 />}
             containerStyles={`bg-blue-500  hover:bg-blue-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline`} />
         </Link>
           <CustomButton
             title='Delete Job'
             iconRight={<FiDelete />}
             onClick={handleDeleteProduct}
             containerStyles={`bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline`} />
         
       </div>

     )}
   </div><DeleteConfirmationDialog
       isOpen={isDeleteConfirmationOpen}
       onCancel={cancelDeleteProduct}
       onConfirm={confirmDeleteProduct} />
        {deleteSuccess && (
        <div
        className="fixed inset-0 p-4 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
        <div className="w-full max-w-lg bg-white shadow-lg rounded-md p-6 relative">
          <div className="my-8 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-16 shrink-0 fill-[#333] inline" viewBox="0 0 512 512">
              <path
                d="M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z"
                data-original="#000000" />
              <path
                d="M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z"
                data-original="#000000" />
            </svg>
            <h4 className="text-2xl text-green-500 font-semibold mt-6">Successfully Delete of Job!</h4>
            <p className="text-sm  mt-4">Upload your job listings to our platform to connect with potential candidates who fit your requirements. Whether you're hiring for a specific role or looking to expand your team, our platform simplifies the recruitment process by matching your job listings with qualified candidates. Get started today and streamline your hiring process with ease.</p>
</div>
          <button type="button"
          onClick={backtojob}
            className="px-6   py-2.5 min-w-[150px] w-full rounded text-white text-sm font-semibold border-none outline-none bg-[#333] hover:bg-[#222]">Got it</button>
        </div>
      </div>
      )}
      {deleteError && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center transition duration-500 ease-in-out transform" style={{ paddingTop: "50px" }}>
          <div className="bg-red-500 text-white px-4 py-2 rounded shadow-lg">
            An error occurred while deleting the job. Please try again later.
          </div>
        </div>
      )} </>
 );
};

export default JobCard;
